/*
 * @Author: wufan 
 * @Date: 2019-08-21 14:33:24 
 * @Last Modified by: wufan
 * @Last Modified time: 2019-08-22 19:16:32
 * 用作图片文字结果提示
 */

import React from 'react';
import './NoResultPage.less';
import {
  withRouter
} from 'react-router-dom';

const NoResultPage = (props: any) => { 
  const searchKey = props.location.pathname.indexOf('/', 5) !== -1 ? props.location.pathname.slice(props.location.pathname.indexOf('/', 5) + 1) : "";

     function clickBtn(e:any){ 
      const btn :any= document.getElementById("btn");
      btn.click();
  };

  return (
    <div className="no-result-page">
      <div className="img-box">
      </div>
      <div className="tip">
        {`抱歉，没有找到和“${searchKey}“相关的结果，请更换关键词或尝试 `}
        <span className="keyword-cls kefu" onClick={clickBtn}>联系客服</span>
      </div>
    </div>
  )
  
}

export default withRouter(NoResultPage);